import { render } from "./RequestObject.vue?vue&type=template&id=7f8c5d10&scoped=true"
import script from "./RequestObject.vue?vue&type=script&lang=js"
export * from "./RequestObject.vue?vue&type=script&lang=js"

import "./RequestObject.vue?vue&type=style&index=0&id=7f8c5d10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8c5d10"]])

export default __exports__